"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAdministrationApi = exports.CustomerAdministrationApiFactory = exports.CustomerAdministrationApiFp = exports.CustomerAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * CustomerAdministrationApi - axios parameter creator
 * @export
 */
const CustomerAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: AddPremiumToUsers - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kullanıcılara premium paketi tanımlar.
         * @param {AddPremiumToUsersCommand} [addPremiumToUsersCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPremiumToUsers: (addPremiumToUsersCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/add_premium_to_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addPremiumToUsersCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteCustomer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşteriyi silindi olarak işaretler. // TODO Bu kısımda hangi bilgilerin değiştirileceği bilgileri gelmesi gerekiyor.
         * @param {DeleteCustomerCommand} [deleteCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: (deleteCustomerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/delete_customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteCustomerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListCustomerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Müşterinin aktivitelerini listeler.
         * @param {number} customerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerActivitiesForAdministration: (customerMetadataId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('listCustomerActivitiesForAdministration', 'customerMetadataId', customerMetadataId);
            const localVarPath = `/api/customer_administration/list_customer_activities_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (customerMetadataId !== undefined) {
                localVarQueryParameter['customerMetadataId'] = customerMetadataId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListCustomersForAdministration - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterileri yönetim amaçlı listelemeyi sağlar. Dikkat: Bu endpointte sadece rolü ROLE_CUSTOMER olan hesaplar listelenmelidir.
         * @param {boolean} [orderByJoinCountOfBroadcasts]
         * @param {number} [page]
         * @param {'ALL' | 'ONLY_NON_PREMIUMS' | 'ONLY_PREMIUMS'} [premiumSearch]
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomersForAdministration: (orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/list_customers_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (orderByJoinCountOfBroadcasts !== undefined) {
                localVarQueryParameter['orderByJoinCountOfBroadcasts'] = orderByJoinCountOfBroadcasts;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (premiumSearch !== undefined) {
                localVarQueryParameter['premiumSearch'] = premiumSearch;
            }
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateEmailOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin e-posta adresini günceller.
         * @param {UpdateEmailOfCustomerCommand} [updateEmailOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfCustomer: (updateEmailOfCustomerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/update_email_of_customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEmailOfCustomerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePasswordOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin şifresini günceller.
         * @param {UpdatePasswordOfCustomerCommand} [updatePasswordOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfCustomer: (updatePasswordOfCustomerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/update_password_of_customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePasswordOfCustomerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePremiumStatusOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin premium durumunu günceller.
         * @param {UpdatePremiumStatusOfCustomerCommand} [updatePremiumStatusOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePremiumStatusOfCustomer: (updatePremiumStatusOfCustomerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer_administration/update_premium_status_of_customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePremiumStatusOfCustomerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CustomerAdministrationApiAxiosParamCreator = CustomerAdministrationApiAxiosParamCreator;
/**
 * CustomerAdministrationApi - functional programming interface
 * @export
 */
const CustomerAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CustomerAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: AddPremiumToUsers - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kullanıcılara premium paketi tanımlar.
         * @param {AddPremiumToUsersCommand} [addPremiumToUsersCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPremiumToUsers(addPremiumToUsersCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addPremiumToUsers(addPremiumToUsersCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteCustomer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşteriyi silindi olarak işaretler. // TODO Bu kısımda hangi bilgilerin değiştirileceği bilgileri gelmesi gerekiyor.
         * @param {DeleteCustomerCommand} [deleteCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(deleteCustomerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCustomer(deleteCustomerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListCustomerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Müşterinin aktivitelerini listeler.
         * @param {number} customerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerActivitiesForAdministration(customerMetadataId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCustomerActivitiesForAdministration(customerMetadataId, page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListCustomersForAdministration - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterileri yönetim amaçlı listelemeyi sağlar. Dikkat: Bu endpointte sadece rolü ROLE_CUSTOMER olan hesaplar listelenmelidir.
         * @param {boolean} [orderByJoinCountOfBroadcasts]
         * @param {number} [page]
         * @param {'ALL' | 'ONLY_NON_PREMIUMS' | 'ONLY_PREMIUMS'} [premiumSearch]
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateEmailOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin e-posta adresini günceller.
         * @param {UpdateEmailOfCustomerCommand} [updateEmailOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfCustomer(updateEmailOfCustomerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmailOfCustomer(updateEmailOfCustomerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePasswordOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin şifresini günceller.
         * @param {UpdatePasswordOfCustomerCommand} [updatePasswordOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePremiumStatusOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin premium durumunu günceller.
         * @param {UpdatePremiumStatusOfCustomerCommand} [updatePremiumStatusOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CustomerAdministrationApiFp = CustomerAdministrationApiFp;
/**
 * CustomerAdministrationApi - factory interface
 * @export
 */
const CustomerAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CustomerAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: AddPremiumToUsers - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kullanıcılara premium paketi tanımlar.
         * @param {AddPremiumToUsersCommand} [addPremiumToUsersCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPremiumToUsers(addPremiumToUsersCommand, options) {
            return localVarFp.addPremiumToUsers(addPremiumToUsersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteCustomer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşteriyi silindi olarak işaretler. // TODO Bu kısımda hangi bilgilerin değiştirileceği bilgileri gelmesi gerekiyor.
         * @param {DeleteCustomerCommand} [deleteCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(deleteCustomerCommand, options) {
            return localVarFp.deleteCustomer(deleteCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListCustomerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Müşterinin aktivitelerini listeler.
         * @param {number} customerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerActivitiesForAdministration(customerMetadataId, page, options) {
            return localVarFp.listCustomerActivitiesForAdministration(customerMetadataId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListCustomersForAdministration - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterileri yönetim amaçlı listelemeyi sağlar. Dikkat: Bu endpointte sadece rolü ROLE_CUSTOMER olan hesaplar listelenmelidir.
         * @param {boolean} [orderByJoinCountOfBroadcasts]
         * @param {number} [page]
         * @param {'ALL' | 'ONLY_NON_PREMIUMS' | 'ONLY_PREMIUMS'} [premiumSearch]
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options) {
            return localVarFp.listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateEmailOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin e-posta adresini günceller.
         * @param {UpdateEmailOfCustomerCommand} [updateEmailOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfCustomer(updateEmailOfCustomerCommand, options) {
            return localVarFp.updateEmailOfCustomer(updateEmailOfCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePasswordOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin şifresini günceller.
         * @param {UpdatePasswordOfCustomerCommand} [updatePasswordOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options) {
            return localVarFp.updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePremiumStatusOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir müşterinin premium durumunu günceller.
         * @param {UpdatePremiumStatusOfCustomerCommand} [updatePremiumStatusOfCustomerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options) {
            return localVarFp.updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CustomerAdministrationApiFactory = CustomerAdministrationApiFactory;
/**
 * CustomerAdministrationApi - object-oriented interface
 * @export
 * @class CustomerAdministrationApi
 * @extends {BaseAPI}
 */
class CustomerAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: AddPremiumToUsers - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Kullanıcılara premium paketi tanımlar.
     * @param {AddPremiumToUsersCommand} [addPremiumToUsersCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    addPremiumToUsers(addPremiumToUsersCommand, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).addPremiumToUsers(addPremiumToUsersCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteCustomer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir müşteriyi silindi olarak işaretler. // TODO Bu kısımda hangi bilgilerin değiştirileceği bilgileri gelmesi gerekiyor.
     * @param {DeleteCustomerCommand} [deleteCustomerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    deleteCustomer(deleteCustomerCommand, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).deleteCustomer(deleteCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListCustomerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Müşterinin aktivitelerini listeler.
     * @param {number} customerMetadataId
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    listCustomerActivitiesForAdministration(customerMetadataId, page, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).listCustomerActivitiesForAdministration(customerMetadataId, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListCustomersForAdministration - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Müşterileri yönetim amaçlı listelemeyi sağlar. Dikkat: Bu endpointte sadece rolü ROLE_CUSTOMER olan hesaplar listelenmelidir.
     * @param {boolean} [orderByJoinCountOfBroadcasts]
     * @param {number} [page]
     * @param {'ALL' | 'ONLY_NON_PREMIUMS' | 'ONLY_PREMIUMS'} [premiumSearch]
     * @param {string} [searchText]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).listCustomersForAdministration(orderByJoinCountOfBroadcasts, page, premiumSearch, searchText, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateEmailOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir müşterinin e-posta adresini günceller.
     * @param {UpdateEmailOfCustomerCommand} [updateEmailOfCustomerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    updateEmailOfCustomer(updateEmailOfCustomerCommand, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).updateEmailOfCustomer(updateEmailOfCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePasswordOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir müşterinin şifresini günceller.
     * @param {UpdatePasswordOfCustomerCommand} [updatePasswordOfCustomerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).updatePasswordOfCustomer(updatePasswordOfCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePremiumStatusOfCustomer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir müşterinin premium durumunu günceller.
     * @param {UpdatePremiumStatusOfCustomerCommand} [updatePremiumStatusOfCustomerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAdministrationApi
     */
    updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options) {
        return (0, exports.CustomerAdministrationApiFp)(this.configuration).updatePremiumStatusOfCustomer(updatePremiumStatusOfCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CustomerAdministrationApi = CustomerAdministrationApi;
